export const UI_TEXT = {
  ru: {
    chooseLanguageTitle: 'Выберите язык анкеты',
    chooseLanguageSubtitle: 'Пожалуйста, выберите язык, на котором вам комфортно заполнять анкету.',
    continueRu: 'Русский',
    continueEn: 'English',
    stepOf: (current, total) => `Шаг ${current} из ${total}`,
    saving: 'Сохранение...',
    saved: 'Сохранено ✓',
    submittedBanner: 'Анкета уже отправлена. Спасибо! Редактирование отключено.',
    requiredBlockTitle: 'Заполните обязательные поля:',
    back: 'Назад',
    next: 'Далее',
    submit: 'Отправить анкету',
    submitting: 'Отправка...',
    loadError: 'Не удалось загрузить анкету',
    schemaUnavailable: 'Схема анкеты недоступна',
    submitSuccess: 'Анкета отправлена',
    submitError: 'Не удалось отправить анкету',
    changeLanguage: 'Сменить язык',
    answerLabel: 'Ответ',
    typeAnswerPlaceholder: 'Введите ответ',
    requiredFieldError: 'Обязательное поле',
    fullNameEnglishHint: 'Имя и фамилию укажите на английском языке (латиницей).',
  },
  en: {
    chooseLanguageTitle: 'Choose your language',
    chooseLanguageSubtitle: 'Please choose the language you are most comfortable with.',
    continueRu: 'Russian',
    continueEn: 'English',
    stepOf: (current, total) => `Step ${current} of ${total}`,
    saving: 'Saving...',
    saved: 'Saved ✓',
    submittedBanner: 'This intake has already been submitted. Thank you. Editing is disabled.',
    requiredBlockTitle: 'Please complete the required fields:',
    back: 'Back',
    next: 'Next',
    submit: 'Submit intake',
    submitting: 'Submitting...',
    loadError: 'Failed to load intake form',
    schemaUnavailable: 'Intake schema is unavailable',
    submitSuccess: 'Intake submitted',
    submitError: 'Failed to submit intake',
    changeLanguage: 'Change language',
    answerLabel: 'Answer',
    typeAnswerPlaceholder: 'Type your answer',
    requiredFieldError: 'This field is required',
    fullNameEnglishHint: 'Please enter first and last name in English (Latin letters).',
  },
};

const STEP_TITLE_EN = {
  intro: 'Introduction',
  personal: 'Personal Information',
  expectations: 'Expectations',
  'meds-allergies': 'Medications & General Health',
  'red-flags': 'Quick Red Flags',
  'medical-1': 'Medical Questionnaire: Part 1',
  'medical-2': 'Medical Questionnaire: Part 2',
  'medical-3': 'Medical Questionnaire: Part 3',
  dental: 'Dental Questionnaire',
  surgical: 'Surgical Extension',
  consent: 'Consent',
};

const STEP_DESCRIPTION_EN = {
  intro:
    'Hello! My name is Artem Naimushin, I am a surgical dentist.\nThank you for your trust and for reaching out.\nIt is important for me to provide maximum safety, predictability, and comfort during treatment.\nThis questionnaire takes 7–10 minutes and helps us assess risks in advance and plan treatment, so we can spend more appointment time on treatment itself.\nPlease answer honestly and thoroughly. All information is confidential and used only for medical purposes.',
};

const SECTION_TITLE_EN = {
  'personal-main': 'Basic Information',
  'expectations-main': 'Treatment Priorities',
  'meds-main': 'Key Medical Context',
  'red-flags-main': 'Critical Risk Factors',
  'medical-1-main': 'Heart, Blood, Breathing',
  'medical-2-main': 'Systemic Conditions',
  'medical-3-main': 'Habits and Wellbeing',
  'dental-header': 'Dental History Header',
  'dental-questions': 'Questions dent_01 ... dent_36',
  'surgical-main': 'Previous Surgical Experience',
  'consent-main': 'Consent Confirmation',
};

const Q_EN = {
  patientRecordId: 'Patient ID',
  fullName: 'Full name',
  preferredName: 'Preferred name',
  dob: 'Date of birth',
  phone: 'Phone',
  email: 'Email',
  sex: 'Sex',
  chiefComplaint: 'Chief complaint',
  goalType: 'Main treatment goal',
  timeframe: 'Preferred timeline',
  priority: 'Your priority',
  anxietyScale: 'How anxious are you before treatment?',
  wantsSedation: 'Are you considering sedation?',
  currentCareDetails:
    'Describe your current medical treatment, upcoming surgeries, genetic/developmental conditions, or other treatments that may affect dental care (for example, Botox/fillers).',
  medsSupplements: 'List all medications, supplements, and vitamins you have taken in the last two years.',
  med_01: 'Hospitalization due to illness or injury',
  med_01_details: 'Please describe',
  med_02:
    'Allergic reaction to medications/materials (aspirin/ibuprofen/acetaminophen/codeine; penicillin; erythromycin; tetracycline; sulfonamides; local anesthetic; fluoride; metals (nickel/gold/silver/other); latex; other)',
  med_02_details: 'Which allergies specifically?',
  med_03: 'Heart problems or cardiac stent placement in the last six months',
  med_04: 'Infective endocarditis',
  med_05: 'Artificial heart valve / congenital defect repair (including PFO)',
  med_06: 'Pacemaker or implantable defibrillator',
  med_07: 'Orthopedic implant (joint replacement)',
  med_07_details: 'Please specify',
  med_08: 'Rheumatic fever or scarlet fever',
  med_09: 'High or low blood pressure',
  med_10: 'Stroke (taking anticoagulants)',
  med_11: 'Anemia or other blood disorder',
  med_12: 'Prolonged bleeding from minor cuts (INR > 3.5)',
  med_13: 'Emphysema, shortness of breath, sarcoidosis',
  med_14: 'Tuberculosis, measles, chickenpox',
  med_15: 'Asthma',
  med_16: 'Breathing or sleep problems (apnea, snoring, sinus issues)',
  med_17: 'Kidney disease',
  med_18: 'Liver disease',
  med_19: 'Jaundice',
  med_20: 'Thyroid/parathyroid disease or calcium deficiency',
  med_21: 'Hormonal insufficiency',
  med_22: 'High cholesterol or cholesterol-lowering medications',
  med_23: 'Diabetes',
  med_23_hba1c: 'If yes, HbA1c (if known)',
  med_24: 'Stomach or duodenal ulcer',
  med_25: 'Digestive disorders (celiac, reflux, etc.)',
  med_26: 'Osteoporosis/osteopenia (for example, bisphosphonate use)',
  med_26_bisphosphonates: 'Do you currently or previously use bisphosphonates?',
  med_27: 'Arthritis',
  med_28: 'Autoimmune disease (RA, lupus, scleroderma, etc.)',
  med_29: 'Glaucoma',
  med_30: 'Contact lenses',
  med_31: 'Head or neck injuries',
  med_32: 'Epilepsy, convulsions, seizures',
  med_33: 'Other neurological condition',
  med_33_details: 'Please specify condition',
  med_34: 'Viral infections and herpes',
  med_35: 'Any oral masses or swellings',
  med_36: 'Hives, skin rash, hay fever',
  med_37: 'Sexually transmitted disease / HPV',
  med_38: 'Hepatitis',
  med_38_type: 'Specify hepatitis type',
  med_39: 'HIV/AIDS',
  med_40: 'Tumor or pathological growths',
  med_41: 'Radiation therapy',
  med_42: 'Chemotherapy or immunosuppressive drugs',
  med_43: 'Emotional problems',
  med_44: 'Psychiatric treatment',
  med_45: 'Antidepressants',
  med_46: 'Alcohol use / recreational drug use',
  med_47: 'Currently treated for any other disease',
  med_48:
    'Any health changes in the last 24 hours (fever, chills, new cough, diarrhea, etc.)',
  med_49: 'Taking medications for weight control',
  med_50: 'Taking dietary supplements',
  med_51: 'Frequent fatigue or exhaustion',
  med_52: 'Frequent headaches',
  med_53: 'Smoke / smoked / use tobacco in any form',
  med_53_tobacco_details: 'Specify tobacco type and duration',
  cigarettesPerDay: 'Cigarettes per day (average)',
  med_54: 'Do you consider yourself sensitive/easily hurt?',
  med_55: 'Do you often feel unhappy or depressed?',
  med_56: 'WOMAN — taking oral contraceptives',
  med_57: 'WOMAN — pregnant',
  med_58: 'MAN — prostate disease',
  lastMedicalExamDate: 'Date of last medical exam',
  lastMedicalExamReason: 'Reason for last medical exam',
  healthRating: 'How would you rate your overall health?',
  oralHealthRating: 'How would you rate your oral health?',
  referringFrom: 'Who referred you?',
  previousDentist: 'Previous dentist',
  yearsWithDentist: 'Years with previous dentist',
  lastDentalExamDate: 'Date of last dental exam',
  lastXrayDate: 'Date of last X-ray',
  lastDentalTreatmentDate: 'Date of last dental treatment',
  regularVisitsInterval: 'How often do you attend regular checkups?',
  urgentProblem: 'Current urgent dental problem',
  dent_01: 'Are you afraid of dental treatment? Rate from 1 to 10',
  dent_01_comment: 'Comment (optional)',
  dent_02: 'Have you ever had an unpleasant dental treatment experience?',
  dent_03: 'Have you ever had complications after dental treatment?',
  dent_04: 'Have you had difficulty with anesthesia or anesthetic complications?',
  dent_05: 'Have you ever worn braces, had orthodontic treatment, bite correction, or occlusal adjustment?',
  dent_05_details: 'Please specify',
  dent_06: 'Are any teeth missing due to developmental absence?',
  dent_06_details: 'Please specify',
  dent_07: 'Do your gums bleed or hurt when brushing/flossing?',
  dent_07_details: 'Please specify',
  dent_08: 'Have you ever had gum treatment or been told you have bone loss around teeth?',
  dent_08_details: 'Please specify',
  dent_09: 'Have you noticed bad taste in your mouth or bad breath?',
  dent_09_details: 'Please specify',
  dent_10: 'Does anyone in your family have periodontitis (gum disease)?',
  dent_11: 'Have you ever had gum recession (exposed tooth roots)?',
  dent_11_details: 'Please specify',
  dent_12: 'Have your teeth ever become loose (without trauma), or is it hard to bite an apple?',
  dent_12_details: 'Please specify',
  dent_13: 'Have you ever experienced a burning sensation in your mouth unrelated to teeth?',
  dent_13_details: 'Please specify',
  dent_14: 'Have you had cavities in the past 3 years?',
  dent_15: 'Do you feel your mouth is dry or have trouble swallowing some foods?',
  dent_15_details: 'Please specify',
  dent_16: 'Do you feel/see pits or grooves on chewing surfaces of teeth?',
  dent_17:
    'Are your teeth sensitive to hot/cold/sweet, painful on biting, or do you avoid brushing a certain area?',
  dent_17_details: 'Please specify',
  dent_18: 'Do you have grooves/notches near the gumline of teeth?',
  dent_19: 'Have you had broken/chipped teeth, toothache, or cracked fillings?',
  dent_19_details: 'Please specify',
  dent_20: 'Does food often get stuck between your teeth?',
  dent_21: 'Do you have TMJ problems? (pain, sounds, limited opening, spasm, clicking)',
  dent_21_details: 'Please specify',
  dent_22: 'When closing your teeth, does your lower jaw feel forced backward?',
  dent_23:
    'Do you have chewing difficulties or avoid gum, carrots, nuts, crackers, baguette, protein bars, or other hard/dry foods?',
  dent_23_details: 'Please specify',
  dent_24: 'Have your teeth changed in the last 5 years — shorter, thinner, worn?',
  dent_25: 'Do you notice increasing crookedness/crowding/overlap of teeth?',
  dent_26: 'Are spaces between teeth increasing, or are teeth becoming more mobile?',
  dent_27: 'To close your teeth, do you need to bite/clench/move your jaw more than once?',
  dent_28: 'Do you keep your tongue between teeth or bite on your tongue for jaw comfort?',
  dent_29: 'Do you have parafunctional habits (ice chewing, nail biting, holding objects with teeth, etc.)?',
  dent_29_details: 'Please specify',
  dent_30: 'Do you clench your teeth during the day to the point of soreness?',
  dent_31:
    'Do you have sleep problems (restless sleep), wake with headaches, or wake feeling your teeth strongly?',
  dent_32: 'Do you currently wear or have you ever worn a dental guard/splint?',
  dent_32_details: 'Please specify',
  dent_33: 'Would you like to change anything about the appearance of your teeth?',
  dent_33_details: 'Please specify',
  dent_34: 'Have you ever had teeth whitening?',
  dent_35: 'Are you embarrassed or uncomfortable because of your teeth appearance?',
  dent_36: 'Have you ever been disappointed with esthetic outcomes of previous treatment?',
  dent_36_details: 'Please specify',
  surg_01_extractionsHistory: 'History of tooth extractions',
  surg_01_complications: 'If complications occurred, which ones?',
  surg_01_details: 'Details about extractions',
  surg_02_implantsHistory: 'History of implants',
  surg_02_issues: 'If implant issues occurred, which ones?',
  surg_02_details: 'Details about implants',
  surg_03_boneSurgery: 'Previous bone procedures',
  surg_03_details: 'Details about bone procedures',
  surg_04_softTissue: 'Previous soft tissue procedures',
  surg_04_details: 'Details about soft tissue procedures',
  surg_05_anesthesiaTolerance: 'How do you tolerate anesthesia?',
  surg_05_details: 'Describe anesthesia reaction',
  surg_06_neuroAfterSurgery: 'Any lip/chin numbness lasting over 1 month after treatment?',
  surg_06_details: 'Please provide details',
  surg_07_healing: 'How does healing usually go after procedures?',
  surg_07_details: 'Describe healing characteristics',
  surg_08_whatLiked: 'What did you like in previous treatment?',
  surg_09_whatDidntLike: 'What did you dislike in previous treatment?',
  consent: 'I confirm that the information is complete and accurate',
  signatureName: 'Full name (as signature)',
};

const OPTION_EN = {
  Да: 'Yes',
  Нет: 'No',
  Женщина: 'Female',
  Мужчина: 'Male',
  Имплантация: 'Implant placement',
  'Удаление зуба': 'Tooth extraction',
  'Боль/воспаление': 'Pain / inflammation',
  Эстетика: 'Esthetics',
  Другое: 'Other',
  'Не срочно': 'Not urgent',
  '1–2 недели': '1–2 weeks',
  'Как можно быстрее': 'As soon as possible',
  Безопасность: 'Safety',
  Скорость: 'Speed',
  Бюджет: 'Budget',
  Отличное: 'Excellent',
  Хорошее: 'Good',
  Среднее: 'Average',
  Плохое: 'Poor',
  '3 мес.': '3 months',
  '4 мес.': '4 months',
  '6 мес.': '6 months',
  '12 мес.': '12 months',
  'Не посещаю в плановом порядке': 'I do not attend regular checkups',
  'Да, без осложнений': 'Yes, without complications',
  'Да, были осложнения': 'Yes, there were complications',
  'Да, успешно': 'Yes, successful',
  'Да, имплантат удаляли': 'Yes, implant was removed',
  'Сухая лунка': 'Dry socket',
  'Сильный отек': 'Severe swelling',
  'Инфекция/нагноение': 'Infection/suppuration',
  'Длительное кровотечение': 'Prolonged bleeding',
  Онемение: 'Numbness',
  'Повторная операция': 'Repeat surgery',
  'Не прижился/потеря импланта': 'Failed osseointegration / implant loss',
  'Инфекция/переимплантит': 'Infection / peri-implantitis',
  'Боль/дискомфорт': 'Pain / discomfort',
  'Сломался компонент': 'Component fracture',
  'Причина неизвестна': 'Unknown cause',
  'Синус-лифтинг': 'Sinus lift',
  'НКР/GBR': 'GBR / guided bone regeneration',
  'Костная аугментация': 'Bone augmentation',
  'Костные блоки': 'Bone blocks',
  'Не знаю': "I don't know",
  'Не было': 'None',
  'Пересадка ткани с нёба': 'Palatal tissue graft',
  'Закрытие рецессий': 'Recession coverage',
  'Увеличение прикрепленной десны': 'Increase of attached gingiva',
  Вестибулопластика: 'Vestibuloplasty',
  'Всегда нормально': 'Always fine',
  'Иногда плохо': 'Sometimes poorly',
  'Были выраженные проблемы': 'Had significant problems',
  'Заживает легко': 'Heals easily',
  'Тяжело (частые воспаления/нагноения/долго)': 'Difficult (frequent inflammation/suppuration/prolonged)',
};

export const getStepTitle = (step, lang) => {
  if (lang === 'en') return STEP_TITLE_EN[step.id] || step.title;
  return step.title;
};

export const getStepDescription = (step, lang) => {
  if (lang === 'en') return STEP_DESCRIPTION_EN[step.id] || step.description || '';
  return step.description || '';
};

export const getSectionTitle = (section, lang) => {
  if (lang === 'en') return SECTION_TITLE_EN[section.id] || section.title || '';
  return section.title || '';
};

export const getQuestionLabel = (question, lang) => {
  if (lang === 'en') return Q_EN[question.id] || question.label;
  return question.label;
};

export const getOptionLabel = (option, lang) => {
  if (lang === 'en') return OPTION_EN[option] || option;
  return option;
};
